import { render, staticRenderFns } from "./InvitePlacementTest.vue?vue&type=template&id=12080077&"
import script from "./InvitePlacementTest.vue?vue&type=script&lang=js&"
export * from "./InvitePlacementTest.vue?vue&type=script&lang=js&"
import style0 from "./InvitePlacementTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports